import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Fleet from './components/Fleet';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CarDetail from './pages/CarDetail';

export default function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={
          <>
            <Hero />
            <Fleet />
            <About />
            <Contact />
            <Footer />
          </>
        } />
        <Route path="/car/:id" element={<CarDetail />} />
      </Routes>
    </>
  );
}